export default {
  assetNotSupported: '{assetDisplayName} nie je priradené k zdroju dát alebo nemá vlastný pohľad vo vzdialenom ovládaní.',
};
